import type { NotificationListRow } from "@/lib/notificationsApi";

export const HUB_NOTIFICATION_ARRIVAL_DISMISS_MS_KEY = "hub.notifications.arrivalDismissMs";

export const DEFAULT_NOTIFICATION_ARRIVAL_DISMISS_SECONDS = 30;
export const MIN_NOTIFICATION_ARRIVAL_DISMISS_SECONDS = 5;
export const MAX_NOTIFICATION_ARRIVAL_DISMISS_SECONDS = 600;

export function clampNotificationArrivalDismissSeconds(value: number): number {
  if (!Number.isFinite(value)) {
    return DEFAULT_NOTIFICATION_ARRIVAL_DISMISS_SECONDS;
  }
  return Math.min(
    MAX_NOTIFICATION_ARRIVAL_DISMISS_SECONDS,
    Math.max(MIN_NOTIFICATION_ARRIVAL_DISMISS_SECONDS, Math.round(value)),
  );
}

export function readNotificationArrivalDismissMs(): number {
  if (typeof localStorage === "undefined") {
    return DEFAULT_NOTIFICATION_ARRIVAL_DISMISS_SECONDS * 1000;
  }
  try {
    const raw = localStorage.getItem(HUB_NOTIFICATION_ARRIVAL_DISMISS_MS_KEY);
    if (raw == null || raw.trim() === "") {
      return DEFAULT_NOTIFICATION_ARRIVAL_DISMISS_SECONDS * 1000;
    }
    const parsed = Number.parseInt(raw, 10);
    return clampNotificationArrivalDismissSeconds(parsed / 1000) * 1000;
  } catch {
    return DEFAULT_NOTIFICATION_ARRIVAL_DISMISS_SECONDS * 1000;
  }
}

export function storeNotificationArrivalDismissMs(milliseconds: number): void {
  if (typeof localStorage === "undefined") {
    return;
  }
  const seconds = clampNotificationArrivalDismissSeconds(milliseconds / 1000);
  try {
    localStorage.setItem(HUB_NOTIFICATION_ARRIVAL_DISMISS_MS_KEY, String(seconds * 1000));
  } catch {
    /* localStorage can be unavailable in private windows */
  }
}

export function rowsForSurfaceEventIds(
  rows: readonly NotificationListRow[],
  surfaceEventIds: readonly string[],
  hiddenEventIds: ReadonlySet<string>,
): NotificationListRow[] {
  const wanted = new Set(surfaceEventIds.map((eventId) => eventId.trim()).filter((eventId) => eventId !== ""));
  if (wanted.size === 0) {
    return [];
  }
  return rows.filter((row) => wanted.has(row.eventId) && !hiddenEventIds.has(row.eventId) && row.readAt == null);
}
